import { PortableTextBlock } from "@portabletext/types";
import { PageProps, SliceComponentProps } from "gatsby";

import { LANGUAGE } from "../../../company/settings/translations";
import { FilterCustomKeys } from "./filtered-queries";

export type Maybe<T> = Readonly<T> | null | undefined;

export type IPortableText = PortableTextBlock;

export type Slug =
  | {
      current: Maybe<string>;
    }
  | Maybe<string>;

export type ILink = {
  slug?: Slug;
  name?: Maybe<string>;
  render?: TypeCTA;
};

export type Photo = {
  image: Maybe<Image>;
  alt: Maybe<string>;
  asset: Queries.CloudinaryMedia;
};
export const enum TypeCTA {
  LINK = "link",
  BUTTON = "button",
  SPAN = "span",
}

export type Image = {
  asset: { id: string };
};

export type TagTitle = "h1" | "h2" | "h3" | "p" | null | undefined;

export type Summary = {
  title?: Maybe<string>;
  text?: unknown;
  photo: Photo;
};

export type Resume = FilterCustomKeys<{
  title?: Maybe<string>;
  text?: unknown;
}>;

export interface IPageProps<T extends object> extends PageProps {
  data: T;
  pageContext: {
    id: string;
    language: LANGUAGE;
  };
}

export interface ISliceProps<T extends object> extends SliceComponentProps {
  data: T;
  sliceContext: {
    language: LANGUAGE;
  };
}

export interface IPagePropsWithPagination<T extends object> extends PageProps {
  data: T;
  pageContext: {
    id: string;
    language: LANGUAGE;
    nextPagePath: string;
    numberOfPages: number;
    humanPageNumber: number;
    pageNumber: number;
    previousPagePath: string;
    rootSlug: string;
    categorySlug?: string;
  };
}
